export default function promiseTimeout<R = any>(
  fn: (...args: any[]) => R | Promise<R>, timeout: number, ...args: any[]
): Promise<R> {
  return new Promise((resolve, reject) => {
    const ret = fn.apply(null, args);
    if (ret instanceof Promise) {
      setTimeout(() => {
        reject('TIMEOUT');
      }, timeout);
      ret.then(resolve);
    } else {
      resolve(ret);
    }
  });
}
